import { Portal } from 'portal-vue';
import Vue from 'vue';

Vue.component('Portal', Portal);
